import React from "react";
import { Image } from "react-native";
import { useErrorStore } from "../store/errorStore";
import Toast, { ToastVariant } from "./Toast";
import { TOAST_DURATION } from "./toastDurations";
import { colors } from "../styles";

// eslint-disable-next-line @typescript-eslint/no-require-imports
const alertIcon = require("../assets/icons/alert-circle.png");

interface ErrorToastProps {
  variant?: ToastVariant;
}

const ICON_TINT: Record<ToastVariant, string> = {
  light: colors.toastLightText,
  dark: colors.toastDarkBody,
  purple: colors.white,
};

export default function ErrorToast({ variant = "dark" }: ErrorToastProps) {
  const errors = useErrorStore((s) => s.errors);
  const latest = errors[0];

  return (
    <Toast
      key={latest?.id}
      title={latest?.title}
      body={latest?.message ?? ""}
      icon={latest?.hideIcon ? undefined : <Image source={alertIcon} style={{ width: 24, height: 24, tintColor: ICON_TINT[variant] }} resizeMode="contain" />}
      variant={variant}
      visible={errors.length > 0}
      duration={latest?.duration ?? TOAST_DURATION.LONG}
      onDismiss={() => {
        if (latest) useErrorStore.getState().removeError(latest.id);
      }}
    />
  );
}
